import { render, staticRenderFns } from "./CostBearersBalanceBottom.vue?vue&type=template&id=2bf9eec8"
import script from "./CostBearersBalanceBottom.vue?vue&type=script&lang=ts"
export * from "./CostBearersBalanceBottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports